import React from 'react';
import { observer } from 'mobx-react';
import { Button, Divider, Form, Header, Icon } from 'semantic-ui-react';
import moment from 'moment';
import Modal from '@components/shared/Modal/';
import InvoicesStore from './InvoicesStore';
import TableToolbar from '@components/shared/tableToolbar';

@observer
class ModalExportBatch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clientId: null,
      clientName: '',
    };
  }

  async componentDidMount() {
    InvoicesStore.setFieldsValue({curPageClientSearch: 1, clientSearchData: []});
    InvoicesStore.fetchClientSearch();
  }

  handleSubmit = e => {
    const { fromDate, toDate } = InvoicesStore.getDateRange();

    const from = moment(
      moment(fromDate).format(`YYYY-MM-DD`),
      'YYYY-MM-DD',
    ).toISOString();
    const to = moment(
      moment(toDate).format(`YYYY-MM-DD`),
      'YYYY-MM-DD',
    ).toISOString();

    var qs = Object.entries({ from, to, clientId: this.state.clientId })
        .map(([key, val]) => `${key}=${val}`)
        .join('&');

    window.open('/Invoice/ExportInvoices?' + qs, '_blank');
  };

  handleScroll = event => {
    const target = event.target;
    const scrollNumber = target.scrollHeight - target.scrollTop;
    const clientHeight = target.clientHeight;
    const curPage = InvoicesStore.curPageClientSearch;
    if (scrollNumber <= clientHeight + 5 && scrollNumber >= clientHeight - 5) {
      InvoicesStore.setFieldsValue({curPageClientSearch: curPage + 1});
      InvoicesStore.fetchClientSearch();
    }
  };

  handleChangeSearchDropdown = e => {
    InvoicesStore.setFieldsValue({curPageClientSearch: 1, keywordClientSearch: e.target.value, clientSearchData: []});
    InvoicesStore.fetchClientSearch();
  };

  renderActionOptions = () => {
    return InvoicesStore.clientSearchData.map(opt => ({
      key: opt.Id,
      text: `No. ${opt.Id} - ${opt.Name || ``} - ${opt.CityName || ``}`,
      value: JSON.stringify({
        id: opt.Id,
        value: opt.Name || '',
      }),
    }));
  };

  handleFilterAction = (_, { value }) => {
    const client = JSON.parse(value);
    this.setState({clientId: client.id, clientName: client.value});
  };

  renderSearchText = value => {
    if (this.state.clientId) {
      const items = InvoicesStore.clientSearchData.filter(opt => opt.Id === value);
      if (items.length > 0) {
        return items[0].Name;
      }
    }

    return InvoicesStore.keywordClientSearch;
  };

  render() {
    const { toggleModal, loadingClient, fromTo } = InvoicesStore;
    return (
      <Modal
        visible={true}
        width={600}
        bodyStyle={{height: '500px'}}
        onCancel={toggleModal(false)}
        footer={
          <React.Fragment>
            <Button disabled={!this.state.clientId} onClick={this.handleSubmit} color="blue">
              Export
            </Button>
            <Button className="negative" onClick={toggleModal(false)}>
              <Icon name="delete" />
              Close
            </Button>
          </React.Fragment>
        }
      >
        <div className="ant-modal-addOrEdit">
          <Form size={'small'}>
            <Form.Field>
              <Header size="medium">Invoice Batch Export - Period: {fromTo}</Header>
              <Divider />
              <TableToolbar.SearchDropdown
                selection
                clearable
                loading={loadingClient}
                onScroll={this.handleScroll}
                search
                onSearchChange={this.handleChangeSearchDropdown}
                options={this.renderActionOptions()}
                onChange={this.handleFilterAction}
                className="Toolbar-input"
                placeholder='Select a client'
                value={this.state.clientName}
              />
            </Form.Field>
          </Form>
        </div>
      </Modal>
    );
  }
}

export default ModalExportBatch;
